import { API_ENDPOINTS } from "../../enums/apiUrls";
import { getBearerToken } from "./bearerToken";

export const medicalPaSubmission = async (orderId: string, formID?: string) => {
  const token = await getBearerToken();
  const body = {
    order_id: orderId,
    form_id: formID,
  };
  if (formID && formID === "ph_medicare_oncology_drug_form") {
    body.form_id = "priority_health_medicare_part_b_oncology";
  } else if (formID === "ph_medicare_nononcology_drug_form") {
    body.form_id = "priority_health_medicare_part_b_general";
  }
  const response = await fetch(API_ENDPOINTS.MEDICAL_PA_SUBMISSION, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      `Request failed with status ${response.status}: ${errorData.message || response.statusText}`,
    );
  }

  return response.json();
};
